export default __webpack_public_path__ + "static/media/forestly-expl-06_EN.5a580c4b.png";